import { memo } from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import { mixed, object, string } from 'yup'

import FormField from 'components/form/FormField'

import useForm from 'hooks/useForm'
import { useStyles } from './styles'

const defaultValues = { entity: '' }

const validations = object().shape({
   entity: string().required('Este campo es requerido')
})

const ProfileSelector = ({ entities = [], onSelect, onExit }) => {
   const classes = useStyles({ entities: entities?.length })
   const { form, createControlledComponent } = useForm({ validations, defaultValues })
   const ControlledFormField = createControlledComponent(FormField)

   const onSumbit = () => {
      onSelect(form.getValues())
   }

   const handleExit = () => {
    form.reset(defaultValues)
    onExit()
   }

   const onErrorSubmit = console.error

   return (
      <form onSubmit={form.handleSubmit(onSumbit, onErrorSubmit)}>
         <Grid container className={classes.header}>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}></Grid>
         </Grid>
         <Grid container className={classes.container}>
            <Button onClick={handleExit}>
               <ArrowBack size="small" />
               <Typography variant="body2">Volver</Typography>
            </Button>
            <Typography variant="h6">Seleccione la entidad con que desea ingresar</Typography>

            <Grid container direction="column">
               <ControlledFormField
                  type="select"
                  fieldName="entity"
                  fieldLabel="Entidad"
                  items={entities}
                  placeholder="Seleccione entidad"
               />
               <Button fullWidth color="primary" variant="contained" type="submit">
                  INGRESAR
               </Button>
            </Grid>
            
            <Grid container className={classes.text}>
               <Typography>¬ Su usuario está asociado con más de una entidad en nuestro sistema.</Typography>
               <Typography>¬ Por favor, seleccione con qué entidad desea trabajar en este momento.</Typography>
               <Typography>
                  ¬ Esta medida asegura que todas las transacciones sean correctamente direccionadas dentro del sistema.
               </Typography>
            </Grid>
         </Grid>
      </form>
   )
}

export default memo(ProfileSelector)
